import { useQuery } from "@tanstack/react-query";
import { fetchCampaigns } from "@/api/campaigns";
import type { CampaignStatus } from "@/types/types";

export function useCampaigns(params?: {
  search?: string;
  status?: CampaignStatus | "all";
  sort?: "redeemed";
}) {
  return useQuery({
    queryKey: ["campaigns", params],
    queryFn: () => fetchCampaigns(params),
    // The My Campaigns list changes as campaigns are sent/redeemed — refetch on every landing.
    refetchOnMount: "always",
  });
}
